import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthStore } from '../stores/auth.store';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authStore = inject(AuthStore);

  if (authStore.isAuthenticated()) {
    return next(
      req.clone({
        headers: req.headers.set('Authorization', `Bearer ${authStore.token()}`),
      }),
    );
  }
  return next(req);
};
